import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "services/queryClient";

export const useDeleteCategoryMutation = () => {
  return useMutation({
    mutationFn: (payload: any) =>
      axiosInstance
        .delete("/products/categories", { data: { categories: payload } })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      message.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["useGetCategory"] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
